"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Check_1 = __importDefault(require("@material-ui/icons/Check"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var react_1 = __importDefault(require("react"));
var SwitchWithStyle_1 = __importDefault(require("./SwitchWithStyle"));
var SwitchWithFocus = function (_a) {
    var label = _a.label, checked = _a.checked, onChange = _a.onChange, divCssStyle = _a.divCssStyle;
    var iconWithBackground = function (Icon, backgroundColor, iconColor) { return (react_1.default.createElement("div", { className: divCssStyle, style: {
            backgroundColor: backgroundColor
        } },
        react_1.default.createElement(Icon, { style: { color: iconColor, fontSize: 16 } }))); };
    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
        react_1.default.createElement(SwitchWithStyle_1.default, { inputProps: {
                'aria-label': label,
                style: { padding: 0 }
            }, checked: checked, onChange: onChange, icon: iconWithBackground(Close_1.default, 'white', '#637381'), checkedIcon: iconWithBackground(Check_1.default, 'white', '#007983') })));
};
exports.default = SwitchWithFocus;
//# sourceMappingURL=SwitchWithFocus.js.map